import SearchNavLink from "../hooks/SearchResultRedirect"
export const ICAMNavroute = [
    {
        typeId: 1,
        name: "Overview",
        hasDropdown: true,
        options: [
            {
                id: "Background of AMRS",
                link: "https://www.africanmrs.net/about-us/",
                redirectNewPage: true
            },
            {
                id: "Local Organizing Committee",
                link: "/iumrs-icam25/organising-commitee",
                redirectNewPage: false
            },
            {
                id: "International Committee",
                link: "/iumrs-icam25/international-commitee",
                redirectNewPage: false

            },
            {
                id: "Winter School 2025",
                link: "/iumrs-icam25/workshop/winter-school",
                redirectNewPage: false

            }
        ]
    },
    {
        typeId: 2,
        name: "Registration",
        hasDropdown: true,
        options: [
            {
                id: "Register Now",
                link: "/iumrs-icam25/registration", /*change footer registration link */
                redirectNewPage: true
            },
            {
                id: "Make/Verify payment",
                link: "/event/payment-initializer",
                redirectNewPage: false
            },
            {
                id: "Registration fee",
                link: "/iumrs-icam25/registration-fee",
                redirectNewPage: false
            }
            
        ]
    },
    {
        typeId: 3,
        name: "Speakers",
        hasDropdown: true,
        options: [
            {
                id: "Plenary speakers",
                link: "/iumrs-icam25/speakers/plenary",
                redirectNewPage: false
            },
            {
                id: "Keynote Speakers",
                link: "/iumrs-icam25/speakers/keynote",
                redirectNewPage: false
            },
            {
                id: "Invited Speakers",
                link: "/iumrs-icam25/speakers/invited",
                redirectNewPage: false
            }
        ]
    },
    {
        typeId: 4,
        name: "Gallery",
        hasDropdown: false,
        link: "/iumrs-icam25/gallery",
        
    },
    {
        typeId: 5,
        name: "Abstract",
        hasDropdown: false,
        link: "/iumrs-icam25/abstract-submission"
    },
    {
        typeId: 6,
        name: "Other",
        hasDropdown: true,
        options: [
            {
                id: "Accommodation",
                link: "/iumrs-icam25/accomodation",
                redirectNewPage: false
            },
            {
                id: "AMRS Ghana",
                link: "/",
                redirectNewPage: false
            },
            {
                id: "Sponsorships",
                link: "/iumrs-icam25/sponsorships",
                redirectNewPage: false
            },
            {
                id: "Travel Details",
                link: "/iumrs-icam25/travel-details",
                redirectNewPage: true
            },
            {
                id: "Venue Info",
                link: "/iumrs-icam25/conference-venue",
                redirectNewPage: false
            },
            {
                id: "Visit Ghana",
                link: "https://visitghana.com/",
                redirectNewPage: true
            }
        ]
    },
];